/**
 * @desc 根据sku列表查询指定仓库库存
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.stock.SkuWarehouseStockGetQry>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/stock/getSkuSpecifyWarehouseStock`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
